import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CrudService } from "src/app/Services/crud.service";
import { LoadingService } from "src/app/Services/loading.service";

@Component({
  selector: "app-generate-ai-content",
  templateUrl: "./generate-ai-content.component.html",
  styleUrl: "./generate-ai-content.component.scss",
  standalone: false,
})
export class GenerateAiContentComponent implements OnInit, AfterViewInit {
  @Input() title;
  @Input() prompt = "";
  @Input() currentProject = {};
  @Input() currentScreen;
  @Input() selectedVersion;
  @Input() projectId;
  @Input() screenId;
  @Input() id;
  @Input() toReWrite = false;
  @Input() userGuideText = "";
  @Output() contentResponseforWfs = new EventEmitter<any>();
  @Output() contentResponseforTooltip = new EventEmitter<any>();
  @Output() contentResponseforFAQ = new EventEmitter<any>();
  @Output() contentResponseforUserGuide = new EventEmitter<any>();
  @Output() isLoaded = new EventEmitter<boolean>();

  formGroup;
  isLoading = false;

  constructor(
    private route: ActivatedRoute,
    private crudService: CrudService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private loadingService: LoadingService
  ) {}
  ngAfterViewInit() {
    if (this.prompt != "") {
      this.formGroup.patchValue({
        prompt: this.prompt,
      });
    }
  }
  ngOnInit() {
    this.formGroup = new FormGroup({
      prompt: new FormControl("", [Validators.required]),
      additionaldetails: new FormControl("", [Validators.required]),
    });
  }

  generateContent() {
    this.loadingService.show();

    this.isLoaded.emit(true);
    var payload = {};
    var url = "";
    payload = this.formGroup.value;
    payload["projectId"] = this.projectId;
    payload["screenId"] = this.screenId;
    payload["primaryLanguage"] = this.currentProject["primaryLanguage"];
    payload["companyId"] = this.currentScreen["companyId"];
    payload["version"] = this.selectedVersion;

    if (this.title == "FAQs") {
      if (this.toReWrite == true) {
        url = "faqs/rewriteanswer";
      } else {
        // url = "faqs/generateFAQFromPortal";
        url = "faqs/generatefaq";
      }
    } else if (this.title == "Workflow-step") {
      url = "workflows/generateDescriptionForSteps";
    } else if (this.title == "Tooltip") {
      url = "tooltips/generateDescriptionFortooltips";
    } else if (this.title == "User Guide") {
      if (this.toReWrite == true) {
        payload["prompt"] += "\n" + this.userGuideText;
        url = "userGuides/reGenerateUserGuide";
      }
    }

    if (this.id != undefined) {
      payload["id"] = this.id;
    }
    this.modalService.dismissAll();
    this.crudService.update(
      payload,
      (val) => {
        if ((val != undefined && val != null) || val?.trim() != "") {
          if (this.title == "FAQs") {
            this.contentResponseforFAQ.emit(val);
          } else if (this.title == "Workflow-step") {
            this.contentResponseforWfs.emit(val);
          } else if (this.title == "Tooltip") {
            this.contentResponseforTooltip.emit(val);
          } else if (this.title == "User Guide") {
            this.isLoaded.emit(false);
            this.contentResponseforUserGuide.emit(val);
          }
        }
      },
      url
    );
  }

  cancel() {
    this.contentResponseforWfs.emit(false); // emit the event
    this.activeModal.close(); // close modal (value not used here)
  }

  openConfirmation(content) {
    this.modalService.open(content);
  }

  closeModal() {
    this.activeModal.close(); // close modal (value not used here)
  }
}
